import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { and } from '@adornis/validation/functions/and.js';
import { minLength } from '@adornis/validation/functions/length.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { ValidationFunctionOptions } from '@adornis/validation/validator.js';

@Entity()
export class PaymentsData extends AdornisEntity {
  static override _class = 'PaymentsData';

  @validate(minLength(1))
  @Field(type => String)
  firstName!: string;

  @validate(minLength(1))
  @Field(type => String)
  lastName!: string;

  @validate(minLength(1))
  @Field(type => String)
  street!: string;

  @validate(minLength(1))
  @Field(type => String)
  zip!: string;

  @validate(minLength(1))
  @Field(type => String)
  city!: string;

  @validate(minLength(1))
  @Field(type => String)
  country!: string;

  @validate(minLength(1))
  @Field(type => String)
  phone?: string;

  @validate(
    and(
      nonOptional({ allowFalsy: true }),
      ({ value, key, target }: ValidationFunctionOptions<boolean, PaymentsData>) => {
        if (!value)
          throw new ValidationError(`Value of ${key} in ${target._class} needs to be true`, {
            translationKey: '',
            key,
            target,
          });
      },
    ),
  )
  @Field(type => Boolean)
  acceptedLegal!: boolean;

  get fullName() {
    return this.firstName + ' ' + this.lastName;
  }
}
